import { IApplicationState } from '../../types/redux';

/**
 * Выбирает все Блоки эксперта
 */
export const selectPostContentExpertBlocks = ({ postContentExpertBlocks }: IApplicationState) =>
  postContentExpertBlocks.items;
